export default __webpack_public_path__ + "static/media/kiril_m.5f00eecf.jpg";